
import React, { Component, useState } from "react";
import { Modal, FloatButton, Form, Input, Select, Upload, Button } from "antd";
import { CloseOutlined, SendOutlined, UploadOutlined } from "@ant-design/icons";
import { t } from "i18next";
import AppContext from "./AppContext";
import { openNotification } from "../utils";
import Api from "../api/Api";
import { DataMerchantChatID, DataMerchantChatID_STG } from "../Data/DataChatID";

const NotificationForm = React.forwardRef(
  ({ handleRoomChange, fileList, setFileList }, ref) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);

    let data = [];
    if (process.env.REACT_APP_ENV === "staging") {
      data = DataMerchantChatID_STG;
    } else {
      data = DataMerchantChatID;
    }

    const baseOptions = Array.isArray(data)
      ? data.map((item) => ({
        label: item.room_name === "all" ? t("All") : item.room_name === "error" ? t("Error") : item.room_name,
        value: item.room_name,
        chat_id: item.chat_id,
        channel: item.channel,
      }))
      : [];

    const roomOptions = [
      { label: t("ส่งทุกห้อง (All)"), value: "SEND_TO_ALL" },
      ...baseOptions
    ];

    const beforeUpload = (file) => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        openNotification("error", "Error", t("คุณสามารถอัปโหลดได้เฉพาะไฟล์ JPG/PNG เท่านั้น!"));
        return Upload.LIST_IGNORE;
      }
      return false;
    };

    const onLocalRoomChange = (values, options) => {
      handleRoomChange(values, options);
      if (values.includes("SEND_TO_ALL")) {
        setDropdownOpen(false);
      }
    };

    const maxCount = 1;

    return (
      <Form layout="vertical" ref={ref}>
        <Form.Item
          name="room_name"
          label={t("Select room")}
          rules={[{ required: true, message: t("กรุณาเลือกห้องที่ต้องการแจ้งเตือน!") }]}
        >
          <Select
            mode="multiple"
            placeholder={t("เลือกห้องแจ้งเตือน (เลือกได้มากกว่า 1 ห้อง หรือเลือก All)")}
            open={dropdownOpen}
            onDropdownVisibleChange={(visible) => setDropdownOpen(visible)}
            options={roomOptions}
            onChange={onLocalRoomChange}
            maxTagCount="count"
          />
        </Form.Item>
        <Form.Item
          name="title"
          label={t("หัวข้อเรื่อง (ถ้ามี)")}
          rules={[
            { required: false },
            { max: 100, message: t("หัวข้อเรื่องต้องไม่เกิน 100 ตัวอักษร") },
          ]}
        >
          <Input maxLength={100} showCount placeholder={t("พิมพ์หัวข้อเรื่อง...")} />
        </Form.Item>

        <Form.Item
          name="message"
          label={t("รายละเอียด (ถ้ามี)")}
          rules={[
            { required: false },
            { max: 2000, message: t("รายละเอียดแจ้งเตือนต้องไม่เกิน 2000 ตัวอักษร") },
          ]}
        >
          <Input.TextArea rows={4} maxLength={2000} showCount placeholder={t("พิมพ์รายละเอียดที่ต้องการ...")} />
        </Form.Item>
        <Form.Item
          name="image"
          label={t("อัปโหลดรูปภาพ (ถ้ามี)")}
          valuePropName="fileList"
          getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
        >
          <Upload
            listType="picture"
            maxCount={maxCount}
            beforeUpload={beforeUpload}
            onChange={({ fileList: newFileList }) => setFileList(newFileList)}
            fileList={fileList}
          >
            <Button icon={<UploadOutlined />}>{t(`เลือกรูปภาพ (Max: ${maxCount})`)}</Button>
          </Upload>
        </Form.Item>
      </Form>
    );
  }
);

class MainChant extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      isModalVisible: false,
      loading: false,
      selectedRoomValues: [], // ✨ ปรับมาเก็บเฉพาะ Array ของ value (เช่น ['test1', 'test2'])
      fileList: []
    };
    this.formRef = React.createRef();
  }

  showModal = () => {
    const { fetchDataSetingNotify } = this.context;
    this.setState(
      { isModalVisible: true, selectedRoomValues: [], fileList: [] },
      () => {
        if (fetchDataSetingNotify) fetchDataSetingNotify();
        this.formRef.current?.resetFields();
      }
    );
  };

  handleRoomChange = (values, options) => {
    if (values.includes("SEND_TO_ALL")) {
      this.formRef.current?.setFieldsValue({ room_name: ["SEND_TO_ALL"] });
      this.setState({ selectedRoomValues: ["SEND_TO_ALL"] });
    } else {
      this.setState({ selectedRoomValues: values }); // เก็บค่าชื่อห้องที่เลือกไว้เป็น Array สตริง
    }
  };

  setFileList = (fileList) => {
    this.setState({ fileList });
  };


  // ฟังก์ชันสร้างการหน่วงเวลา
  delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  handleOk = async () => {
    this.setState({ loading: true });
    try {
      const values = await this.formRef.current.validateFields();
      const imageFiles = values.image || [];
      const imageFileObj = imageFiles.length > 0 ? imageFiles[0].originFileObj : null;

      const alertTitle = values.title ? `<b>📢 ${values.title}</b>` : "";
      const alertMessage = values.message ? values.message : "";

      let formattedText = "";
      if (alertTitle && alertMessage) {
        formattedText = `${alertTitle}\n\n${alertMessage}`;
      } else {
        formattedText = alertTitle || alertMessage || "";
      }

      if (formattedText.trim() === "" && !imageFileObj) {
        throw new Error(t("กรุณากรอกข้อความ หรือ อัปโหลดรูปภาพอย่างน้อย 1 อย่าง"));
      }

      let sourceData = [];
      if (process.env.REACT_APP_ENV === "staging") {
        sourceData = DataMerchantChatID_STG;
      } else {
        sourceData = DataMerchantChatID;
      }

      let targetRooms = [];
      if (values.room_name.includes("SEND_TO_ALL")) {
        targetRooms = Array.isArray(sourceData) ? sourceData : [];
      } else {
        targetRooms = Array.isArray(sourceData)
          ? sourceData.filter(item => this.state.selectedRoomValues.includes(item.room_name))
          : [];
      }

      if (targetRooms.length === 0) {
        throw new Error(t("ไม่พบข้อมูลห้องที่ต้องการส่งแจ้งเตือน"));
      }

      const responses = [];
      let failedCount = 0; // เก็บจำนวนห้องที่ส่งไม่ผ่านไว้ทำ Log

      // วนลูปส่งทีละห้องอย่างเป็นระเบียบ
      for (const room of targetRooms) {
        const targetChatId = room.chat_id;

        if (!targetChatId) {
          console.warn(`Room ${room.room_name} ไม่มีข้อมูล chat_id ข้ามการส่งอันนี้`);
          continue;
        }

        const sendData = new FormData();
        sendData.append("chat_id", targetChatId);
        sendData.append("message", formattedText);
        if (imageFileObj) {
          sendData.append("image", imageFileObj);
        }

        try {
          // สั่งยิง API และรอผลลัพธ์
          const res = await Api.getApiNofAllTelegram(sendData);
          responses.push(res);
          console.log(`✅ ส่งข้อความไปห้อง [${room.room_name}] สำเร็จ`);
        } catch (apiError) {
          // ✨ ข้ามห้องที่พังทันที ไม่ว่าจะเป็นเพราะ Token เพี้ยน, บอทไม่ได้อยู่ในกลุ่ม หรือเน็ตเวิร์กหลุด
          failedCount++;
          console.error(`❌ เกิดข้อผิดพลาดข้ามการส่งที่ห้อง [${room.room_name}]:`, apiError?.message || apiError);
        } finally {
          // ✨ ย้ายมาอยู่ตรงนี้: ไม่ว่าจะส่งสำเร็จ (try) หรือส่งพัง (catch) บอทจะยอมหน่วงเวลา 900ms เสมอ
          // เพื่อรักษาโครงสร้างความถี่ (Rate Limit) ไม่ให้ส่งห้องถัดไปเร็วเกินไปจนพังตามกันครับ
          await this.delay(1000);
        }
      }

      // ตรวจสอบผลลัพธ์หลังจากวนลูปครบทั้ง 14 ห้องแล้ว
      if (responses.length > 0) {
        const viewedIds = JSON.parse(localStorage.getItem("viewedNotifyIds") || "[]");
        responses.forEach(res => {
          let id = res.data?.data?.msg?.id || res.data?.result?.message_id;
          if (id && !viewedIds.includes(id)) viewedIds.push(id);
        });
        localStorage.setItem("viewedNotifyIds", JSON.stringify(viewedIds));

        // แสดง Alert แจ้งเตือนความสำเร็จตามสัดส่วนจริง
        if (failedCount > 0) {
          openNotification("warning", "ส่งข้อมูลเสร็จสิ้นบางส่วน", t(`ส่งสำเร็จ ${responses.length} ห้อง และล้มเหลว ${failedCount} ห้อง (ตรวจสอบเพิ่มเติมที่ Console)`));
        } else {
          openNotification("success", "success", t("ส่งข้อความแจ้งเตือนสำเร็จเรียบร้อยแล้วทุกห้อง!"));
        }

        // ปิด Modal และเคลียร์ค่าอินพุตทั้งหมดเมื่อมีห้องที่สำเร็จ
        this.setState({ isModalVisible: false, loading: false, fileList: [] });
        this.formRef.current.resetFields();
      } else {
        // กรณีแย่ที่สุดคือพังหมดทั้ง 14 ห้อง (responses เป็นอาเรย์ว่างเปล่า)
        throw new Error(t("ไม่สามารถส่งข้อความออกไปยังห้องใดๆ ได้เลย โปรดตรวจสอบสิทธิ์ของบอทในกลุ่ม"));
      }
    } catch (error) {
      console.error("Failed to send notification:", error);
      openNotification("error", "Error", error.message || t("เกิดข้อผิดพลาดในการส่งแจ้งเตือน"));
      this.setState({ loading: false });
    }
  };

  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };

  render() {
    let { isModalVisible, loading, fileList } = this.state;
    const { resProfileAdmin } = this.context;
    const { admin_type } = resProfileAdmin || {};
    let showBTN = ["programer"].includes(admin_type);
    return (
      <>
        {showBTN ? (
          <FloatButton
            onClick={this.showModal}
            title={t("ส่งข้อความแจ้งเตือน")}
            className="sm-bottom-70"
            style={{ insetBlockEnd: 155 }}
            icon={isModalVisible ? <CloseOutlined /> : <SendOutlined />}
          />
        ) : null}

        <Modal
          title={t(`ประกาศแจ้งเตือน`)}
          open={isModalVisible}
          style={{ top: 10 }}
          onOk={this.handleOk}
          confirmLoading={loading}
          onCancel={this.handleCancel}
          okText={<><SendOutlined /> {loading ? t("Processing") : t("Send")}</>}
          cancelText={t("cancel")}
        >
          <NotificationForm
            ref={this.formRef}
            handleRoomChange={this.handleRoomChange}
            fileList={fileList}
            setFileList={this.setFileList}
          />
        </Modal>
      </>
    );
  }
}

export default MainChant;